export default
{
    PaymentTypes: [],
    PaymentType: {},
}
